import React from 'react'
import useLongPress from '../useLongPress';


const Rawdata = (props) => {
  return (
    <div className='rawdata'>
      <div style={{ fontSize: 30, fontWeight: "bold", color: "white", borderBottom: "solid" }}>Weekly Data</div>
      {props.rawdata
        .sort((a, b) => {
          return parseInt(b.week, 10) - parseInt(a.week, 10);
          // if(b.week < a.week) { return 1; }
          // if(b.week > a.week) { return -1; }
          // return 0;
        })
        .map(row => <RawdataRow key={row.week} {...row} onLongPress={props.onEditWeight} />)}
    </div>
  );
};

const RawdataRow = (props) => {
  const isEditable = props.week !== 'Week';
  const longPressHandlers = useLongPress(() => {
    if (isEditable && props.onLongPress) {
      props.onLongPress(props.week, props.weight);
    }
  }, 500);

  return (
    <div>
      <div className='rawdataGrid'>
        <div className='rawdataTitle'></div>
        <div className='standingsRow'>{props.week}</div>
        <div className='standingsRow' style={isEditable ? { cursor: 'pointer' } : {}} {...(isEditable ? longPressHandlers : {})}>{props.weight}</div>
      </div>
    </div>
  );
};
export default Rawdata;
